<template>
  <div class="el-button-dict" ref="container">
    <div class="title">基础用法</div>
    <div class="normal-tag">
      <el-button-dict dictType="PERSON_TYPE" :value="value1"></el-button-dict>
      <el-button-dict type="success" dictType="PERSON_TYPE" :value="value2"></el-button-dict>
      <el-button-dict type="info" dictType="PERSON_TYPE" :value="value3"></el-button-dict>
      <el-button-dict type="warning" dictType="PERSON_TYPE" :value="value4"></el-button-dict>
      <el-button-dict type="danger" dictType="PERSON_TYPE" :value="value5"></el-button-dict>
    </div>

    <div class="title">使用函数</div>
    <div class="function-tag">
      <el-button-dict :judgeTypeFun="judgeTypeFun" dictType="PERSON_TYPE" :value="value1"></el-button-dict>
      <el-button-dict :judgeTypeFun="judgeTypeFun" dictType="PERSON_TYPE" :value="value2"></el-button-dict>
      <el-button-dict :judgeTypeFun="judgeTypeFun" dictType="PERSON_TYPE" :value="value3"></el-button-dict>
      <el-button-dict :judgeTypeFun="judgeTypeFun" dictType="PERSON_TYPE" :value="value4"></el-button-dict>
      <el-button-dict :judgeTypeFun="judgeTypeFun" dictType="PERSON_TYPE" :value="value5"></el-button-dict>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      value1: "001",
      value2: "002",
      value3: "003",
      value4: "004",
      value5: "005"
    }
  },
  mounted() {
    this.$nextTick(() => {
      const container = this.$refs.container
      const data = {"demoContainerHeight": container.scrollHeight + 20}
      window.parent.postMessage(data, "*")
    })
  },
  methods: {
    //val 为字典数据值
    judgeTypeFun(val) {
      const typeObj = {
        "001": "danger",
        "002": "warning",
        "003": "info",
        "004": "success",
        "005": "primary"
      }
      return typeObj[val]
    }
  }
}
</script>

<style lang="less" scoped>
.el-button + .el-button{
  margin-left: 10px;
}
</style>